import api from "../services/api";

export const FETCH_SKILLS_START = "FETCH_SKILLS_START";
export const FETCH_SKILLS_SUCCESS = "FETCH_SKILLS_SUCCESS";
export const FETCH_SKILLS_ERROR = "FETCH_SKILLS_ERROR";

export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";

export function onFetchSkillsSuccess(data) {
  return {
    type: FETCH_SKILLS_SUCCESS,
    data
  };
}

export function onGetCategoriesSuccess(data) {
  return {
    type: GET_CATEGORIES_SUCCESS,
    data
  };
}

export function fetchSkills() {
  return dispatch => {
    api
      .getSkills()
      .then(res => {
        dispatch(onFetchSkillsSuccess(res.data));
      })
      .catch(() => {});
  };
}

export function getCategories() {
  return dispatch => {
    api
      .getCategories()
      .then(res => {
        dispatch(onGetCategoriesSuccess(res.data));
      })
      .catch(() => {});
  };
}



// WEBPACK FOOTER //
// ./src/actions/skills.actions.js